import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, fromThemeColors, styleUtils, ThemeColor } from '@sharefiledev/flow-web';

export const StyledButtonWrapper = styled(Button.Wrapper)({
	overflow: 'hidden',
});

export const StyledItemName = styled.span({
	fontSize: '12px',
	lineHeight: '24px',
	paddingLeft: '10px',
	...styleUtils.ellipsis,
});

export const StyledItemNameCell = styled.div({
	display: 'flex',
	alignItems: 'center',
	margin: '3px 5px 3px 2px',
});

export const StyledItemButton = styled(Button.Wrapper)({
	overflow: 'hidden',
});

export const StyledRadio = styled.div({
	margin: '0 10px 0 0',
	minWidth: '22px',
	cursor: 'default',
});

const selectedCss = (props: { theme: Theme }) => css`
	background: ${fromThemeColors(ThemeColor.listItemSelectedBackground)(props)};
`;

export const StyledRadioItem = styled.div<{ isChecked: boolean }>`
	padding: 3px 0;
	height: 45px;
	display: flex;
	align-items: center;
	overflow: hidden;
	:hover {
		background: ${fromThemeColors(ThemeColor.listItemHoverBackground)};
	}
	:focus {
		outline: none;
		${styleUtils.focusInset};
	}
	:active {
		box-shadow: none;
	}
	${props => props.isChecked && selectedCss};
`;
